"use client";

import { useIntersectionObserverAPI } from "@frend-digital/ui/hooks";
import { atom, useAtom } from "jotai";
import styles from "./StickyAtc.module.css";
export interface StickyATCProps {
	children?: React.ReactNode;
}

const stickyATCAtom = atom<boolean>(false);

const StickyATCSentinel = () => {
	const [_, setDisplay] = useAtom(stickyATCAtom);

	const obserrver = useIntersectionObserverAPI(([entry]) => {
		if (entry?.boundingClientRect.top) {
			setDisplay(!entry.isIntersecting && entry.boundingClientRect.top < 0);
		}
	});

	return (
		<span
			ref={(element) => {
				obserrver?.observe(element!);
				return () => {
					obserrver?.disconnect();
				};
			}}
		/>
	);
};

export const StickyATC = ({ children }: StickyATCProps) => {
	const [showButton] = useAtom(stickyATCAtom);

	if (!showButton)
		return (
			<>
				<StickyATCSentinel />
			</>
		);

	return (
		<>
			<StickyATCSentinel />
			<div className={styles.root}>{children}</div>
		</>
	);
};
